module.exports = __webpack_public_path__ + "img/move.40339f46.svg";